import { signal } from '@preact/signals';
import { useEffect } from 'preact/hooks';

import type { HuisrondePanel } from './HuisrondePanel.js';
import type { HuisrondeWidget } from './HuisrondeWidget.js';

// Huisronde (0075): de pagina (Eten › Huisronde) en de kaart op Vandaag zitten in eigen chunks;
// Eten en Vandaag importeren alleen dit.

const panel = signal<typeof HuisrondePanel | null>(null);
const widget = signal<typeof HuisrondeWidget | null>(null);

export function LazyHuisrondePanel() {
  useEffect(() => {
    if (!panel.value) {
      void import('./HuisrondePanel.js')
        .then((m) => (panel.value = m.HuisrondePanel))
        .catch(() => undefined);
    }
  }, []);
  const P = panel.value;
  return P ? <P /> : null;
}

export function LazyHuisrondeWidget(props: { tick: number }) {
  useEffect(() => {
    if (!widget.value) {
      void import('./HuisrondeWidget.js')
        .then((m) => (widget.value = m.HuisrondeWidget))
        .catch(() => undefined);
    }
  }, []);
  const W = widget.value;
  return W ? <W {...props} /> : null;
}
